angular.module('bmsApp.directives').factory('VisitRiskAssessmentResponseSvc', [
	'$rootScope',
	'$modal',
	'CRUDSvc',
	function (
		$rootScope,
		$modal,
		CRUDSvc) {

	return {
		showVisitRiskAssessmentModal: function (visitType, visit) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/visit-risk-assessment-response/templates/VisitRiskAssessmentResponseModal.html',
				controller: 'VisitRiskAssessmentResponseModalCtrl',
				size: 'md',
				scope: $rootScope,
				resolve: {
					visitType: function () {
						return angular.copy(visitType)
					},
					visit: function () {
						return angular.copy(visit)
					},
				}
			});
		},

		index: function (params) {
			return CRUDSvc.get('api/risk-assessment-response/index', params);
		},
	};

}]);
